<template>
    <b-modal
        :id="modalId"
        size="xl"
        hide-footer
        body-class="overflow-auto p-0"
        centered
        :title="item?.product || $t('availability')"
        @hidden="handleHidden()"
    >
        <EChart :options="chartData" card class="shadow-none m-0" />
    </b-modal>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'ModalAverageAvailabilityByProductsItem',
        components: {
            EChart,
        },
        data() {
            return {
                modalId: 'ModalAverageAvailabilityByProductsItem',
                item: null,
            };
        },
        computed: {
            chartData() {
                const perShop = this.item?.allPriceOccurrences;
                if (!perShop || Object.keys(perShop).length === 0) {
                    return { series: [] };
                }

                const shopLabels = Object.keys(perShop);

                const apexData = shopLabels.map(shopName => {
                    const segments = (perShop[shopName] || [])
                        .map(seg => {
                            const startTs = Number(seg?.start);
                            const endTs = Number(seg?.end);
                            if (!Number.isFinite(startTs) || !Number.isFinite(endTs) || startTs > endTs) return null;
                            return { x: shopName, y: [startTs, endTs] };
                        })
                        .filter(Boolean);

                    return { name: shopName, data: segments };
                });

                const series = apexData.map(row => ({
                    name: row.name,
                    type: 'rangeBar',
                    data: [row],
                }));

                return {
                    xAxis: { type: 'time' },
                    yAxis: {
                        type: 'category',
                        data: shopLabels,
                    },
                    series,
                };
            },
        },
        methods: {
            initItem(item) {
                this.item = item;
            },
            handleHidden() {
                this.item = null;
            },
        },
        mounted() {
            this.$root.$on(this.modalId, this.initItem);
        },
        beforeDestroy() {
            this.$root.$off(this.modalId, this.initItem);
        },
    };
</script>
